import { render } from "./PaginationBox.vue?vue&type=template&id=c3aefe5a&scoped=true"
import script from "./PaginationBox.vue?vue&type=script&lang=js"
export * from "./PaginationBox.vue?vue&type=script&lang=js"

import "./PaginationBox.vue?vue&type=style&index=0&id=c3aefe5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3aefe5a"]])

export default __exports__